import Calendar from "./Calendar";
// import Slideshow from "./Slideshow";
import { Carousel } from './Carousel';

function Landing() {
  const carouselData = [
    // { src: "/images/home/BeerBike2024.jpg", alt: "Beer Bike Powder 2024" },
    // { src: "/images2025-26/fall2025-banner/wiess-seniors.jpg", alt: "Wiess Seniors Beer Bike 2025" },
      { src: "/images2026-27/fall2026-banner/all-wiess.jpg", alt: "Wiess Beer Bike 2026" },
    { src: "/images/s2025-banner/TFW.jpg", alt: "Wiess O-Week 2024" },
    { src: "/images2025-26/fall2025-banner/beer-bike-hype.jpg", alt: "Beer Bike Win 2025" },
    { src: "/images2026-27/fall2026-banner/oweek-ohyeah.jpeg", alt: "Wiess O-Week Welcome" },
    // { src: "/images/s2025-banner/OWeekPAAs2024.jpg", alt: "Wiess O-Week PAAs 2024" },
    { src: "/images2026-27/fall2026-banner/wiess-finest.jpg", alt: "Wiess Finest 2025" },
    { src: "/images2026-27/fall2026-banner/ice-skating.jpg", alt: "Wiess Skate 2025" },
    { src: "/images/s2025-banner/PumpkinCaroling.jpg", alt: "My GOAT Luiz 2024" },
    { src: "/images2026-27/fall2026-banner/wiess-beach.jpg", alt: "Summit 2025" },
    // { src: "/images/s2025-banner/PaintingUpdated.jpg", alt: "TFFW Painting 2024" },
    // { src: "/images/home/CollegeNight2024.jpg", alt: "College Night 2024" },
    // { src: "/images/home/PigFloat2024.jpg", alt: "Pig Float 2024" },
    { src: "/images2025-26/fall2025-banner/firepit.jpg", alt: "Firepit Cab 2025" },
    // { src: "/images/home/Volleyball2024.jpg", alt: "Volleyball 2024" },
    { src: "/images2026-27/fall2026-banner/wiess-laughing.jpg", alt: "Beer Debates 2025" },

    // Add more items as needed
  ];

  const banner = () => {
    return (
      <button
        style={{ zIndex: 100}}
        name="Committees"
        id="committees-banner"
        className="alert-banner"
      >
      <a href="newstudents" style={{ fontFamily: 'EB Garamond, serif', color: 'white' }}>
         Welcome to Wiess College!
      </a>
      </button>
    );
  };

  const welcome = () => {
    return (
      <div
        data-w-id="d25a4d8a-92c3-be77-917b-106bdb906dcf"
        className="welcome-msg-wrap"
        style={{ overflow: "auto" }}
      >
        <div style={{ maxWidth: "100%", whiteSpace: "normal" }}>
          <h2 className="d1">Welcome to</h2>
          <h1 className="d2" style={{ maxWidth: "100%", whiteSpace: "normal" }}>
            Wiess College
          </h1>
        </div>
        {/* <img
          style={{ marginTop: "30px" }}
          height="30"
          src="images/general/saagardhanjani.png"
          alt="saagar dhanjani"
        /> */}
      </div>
    );
  };

  return (
    <div className="content">
      {banner()}

      <div className="landing-wrap">
        <div className="w-container">
          <div className="welcome-hero-wrap">
            {welcome()}
          </div>
          <Carousel data={carouselData} />
          <Calendar />
        </div>
      </div>
    </div>
  );
}

export default Landing;
